import config from './config';
import memoize from '../utils/fp/memoize';
import fetchJSON from '../utils/fetch/fetchJSON';

const successObject = result => result[0] || null;
const successArray = result => result || [];

/**
 * Gets the geolocation details by zipcode.
 * It returns the first county found for the provided zipcode.
 *
 * @param  {String} zipcode: the zipcode to get counties
 * @param  {Boolean} all: determines whether should resolve an array with all results
 * @return {Promise}
 */
function getLocationByZip(zipcode, all) {
  return fetchJSON({
    url: `${config.geoLocation}GeoLocation/${zipcode}`,
    method: 'GET',
  }).then(all ? successArray : successObject);
}

/**
 * Stores in cache each promise returned by zipcode
 */
export default memoize(getLocationByZip);
